"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistenceCheck = exports.EmailQuery = exports.AccountQuery = exports.SearchUsersQuery = exports.ListUsersQuery = exports.EmailHistory = exports.EmailHistoryItem = exports.DeleteAccountPayload = exports.UpdateAccountPayload = exports.CreateAccountPayload = exports.ProfilePage = exports.Profile = exports.DealerLocationSummary = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const Net = __importStar(require("../../../../../net"));
const Tenant = __importStar(require("../../../../tenant"));
const DomainUser = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const field_1 = require("../../../openapi/field");
const ExistenceCheck = __importStar(require("./existence-check"));
exports.ExistenceCheck = ExistenceCheck;
exports.NAMESPACE = 'Culligan.Api.V1.Admin.User.Schema';
const emailFormat = effect_1.Schema.String.annotations({ jsonSchema: { type: 'string', format: 'email' } });
const optionalEmail = (description) => effect_1.Schema.optionalWith(Net.Email, { exact: true }).annotations({ description });
const optionalDateTime = (description) => effect_1.Schema.optionalWith(effect_1.Schema.NullOr((0, field_1.dateTime)(description)), { exact: true }).annotations({ description });
const emptyObject = {
    type: 'object',
    additionalProperties: false,
    properties: {},
};
exports.DealerLocationSummary = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Dealer location id'),
    code: (0, field_1.nonEmpty)('Dealer code'),
    name: (0, field_1.nonEmpty)('Dealer or dealership name'),
    country: (0, field_1.nonEmpty)('Country'),
    region: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Region code, when present',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DealerLocationSummary`,
    description: 'Dealer location fields appended to an admin user profile',
});
exports.Profile = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Stored user id'),
    userId: (0, field_1.nonEmpty)('User id (copy of id added by parseUserRecord)'),
    email: effect_1.Schema.propertySignature(emailFormat).annotations({ description: 'User email' }),
    globalRoles: effect_1.Schema.propertySignature(effect_1.Schema.Array(DomainUser.GlobalUserRole)).annotations({
        description: 'Roles assigned to the user',
    }),
    firstName: (0, field_1.optionalNullableString)('First name'),
    lastName: (0, field_1.optionalNullableString)('Last name'),
    country: (0, field_1.optionalNullableString)('Country of residence'),
    countryCode: (0, field_1.optionalNullableString)('ISO 3166 Alpha-3 country code'),
    mobilePhoneNumber: (0, field_1.optionalNullableString)('Mobile phone number'),
    address: (0, field_1.optionalNullableString)('Street address'),
    addressExtra: (0, field_1.optionalNullableString)('Extra address information'),
    city: (0, field_1.optionalNullableString)('City'),
    zip: (0, field_1.optionalNullableString)('ZIP / postal code'),
    state: (0, field_1.optionalNullableString)('State / province'),
    region: (0, field_1.optionalNullableString)('User region'),
    dealerId: (0, field_1.optionalNullableString)('Reference dealer id'),
    dealerIds: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Array(effect_1.Schema.String)), { exact: true }).annotations({
        description: 'Dealer location ids assigned to this user',
    }),
    dealerLocations: effect_1.Schema.optionalWith(effect_1.Schema.Array(exports.DealerLocationSummary), { exact: true }).annotations({
        description: 'Dealer locations resolved from dealerIds',
    }),
    dealerToolsRole: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(DomainUser.ExternalDealerToolsUserRole), {
        exact: true,
    }),
    accountNumber: (0, field_1.optionalNullableString)('Customer account number'),
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    tenant: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Tenant.Tenant), { exact: true }).annotations({
        description: 'Resolved tenant, or null',
    }),
    externalUserId: (0, field_1.optionalNullableString)('User id on the external identity provider'),
    linkedExternalAccounts: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Accounts on third-party identity providers',
    }),
    metaData: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Legacy user metadata',
    }),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
    passwordChangedAt: optionalDateTime('ISO-8601 password-change time'),
    lastLoginAt: optionalDateTime('ISO-8601 last-login time'),
    linkedAccounts: effect_1.Schema.propertySignature(effect_1.Schema.Struct({}).annotations({ jsonSchema: emptyObject })).annotations({
        description: 'Legacy linked-account projection; currently always empty',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Profile`,
    description: 'Admin user profile returned by parseUserRecord',
});
exports.ProfilePage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Profile),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(openapi_1.Response.ProviderMetadata, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ProfilePage`,
    description: 'Paginated user profiles',
});
const mutationOptionalFields = {
    email: optionalEmail('User email'),
    firstName: (0, field_1.optionalString)('First name'),
    lastName: (0, field_1.optionalString)('Last name'),
    country: (0, field_1.optionalString)('Country of residence'),
    countryCode: (0, field_1.optionalString)('ISO 3166 Alpha-3 country code'),
    mobilePhoneNumber: (0, field_1.optionalString)('Mobile phone number'),
    address: (0, field_1.optionalString)('Street address'),
    addressExtra: (0, field_1.optionalString)('Extra address information'),
    city: (0, field_1.optionalString)('City'),
    zip: (0, field_1.optionalString)('ZIP / postal code'),
    state: (0, field_1.optionalString)('State / province'),
    dealerId: (0, field_1.optionalString)('Reference dealer id'),
    dealerIds: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Dealer location ids',
    }),
    dealerToolsRole: effect_1.Schema.optionalWith(DomainUser.ExternalDealerToolsUserRole, { exact: true }),
    // express-validator has no body("roles") rule. Unknown values are rejected
    // later by validateAssignableRoles via S.Array(GlobalUserRole) (422).
    roles: effect_1.Schema.optionalWith(effect_1.Schema.Array(DomainUser.GlobalUserRole), { exact: true }).annotations({
        description: 'Roles assigned to the user; user is added automatically',
    }),
    accountNumber: (0, field_1.optionalString)('Customer account number'),
    tenantId: (0, field_1.optionalString)('Tenant id'),
};
exports.CreateAccountPayload = effect_1.Schema.Struct({
    ...mutationOptionalFields,
    email: effect_1.Schema.propertySignature(Net.Email).annotations({ description: 'User email' }),
    firstName: (0, field_1.nonEmpty)('First name'),
    lastName: (0, field_1.nonEmpty)('Last name'),
    country: (0, field_1.nonEmpty)('Country of residence'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateAccountPayload`,
    description: 'Request body to create a user and send an invitation',
});
exports.UpdateAccountPayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('User id'),
    ...mutationOptionalFields,
    email: optionalEmail('Validated but not applied: the admin update does not change the login email.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.UpdateAccountPayload`,
    description: 'Request body to update a user',
});
exports.DeleteAccountPayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('User id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeleteAccountPayload`,
    description: 'Request body to delete a user',
});
exports.EmailHistoryItem = effect_1.Schema.Struct({
    messageId: effect_1.Schema.String,
    from: effect_1.Schema.propertySignature(emailFormat).annotations({ description: 'Sender email' }),
    to: effect_1.Schema.propertySignature(emailFormat).annotations({ description: 'Recipient email' }),
    subject: effect_1.Schema.String,
    status: effect_1.Schema.String,
    opens: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    clicks: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    updatedAt: (0, field_1.dateTime)('Last SendGrid event time'),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailHistoryItem`,
    description: 'SendGrid message activity record',
});
exports.EmailHistory = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.EmailHistoryItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailHistory`,
    description: 'Up to 50 SendGrid message activity records',
});
const PositiveIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive());
const page = effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true });
const orderBy = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true });
const orderDir = effect_1.Schema.optionalWith(effect_1.Schema.Literal('asc', 'desc'), { exact: true });
exports.ListUsersQuery = effect_1.Schema.Struct({
    page,
    pageSize: effect_1.Schema.optionalWith(PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(1000)), {
        exact: true,
    }).annotations({ description: 'Default 50.' }),
    size: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }).annotations({
        description: 'Validated but ignored on this endpoint; use pageSize.',
    }),
    orderBy,
    orderDir,
}).annotations({
    identifier: `${exports.NAMESPACE}.ListUsersQuery`,
});
exports.SearchUsersQuery = effect_1.Schema.Struct({
    userId: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    firstName: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    lastName: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    email: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    dealerId: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    tenantId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    accountNumber: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    hasDealerLocationId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    multiSearch: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    accountClass: effect_1.Schema.optionalWith(effect_1.Schema.Literal('enduser', 'operator', 'dealer'), { exact: true }),
    roles: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Comma-separated roles',
    }),
    address: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    addressExtra: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    city: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    country: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    state: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    zip: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    mobilePhoneNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    excludeEndUsers: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false', '1', '0'), { exact: true }),
    page,
    pageSize: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }).annotations({
        description: 'Aliases: size, limit (priority pageSize > size > limit). Default 1000; values above 10000 are capped.',
    }),
    size: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }).annotations({
        description: 'Alias of pageSize.',
    }),
    limit: effect_1.Schema.optionalWith(PositiveIntFromString, { exact: true }).annotations({
        description: 'Alias of pageSize.',
    }),
    orderBy,
    orderDir,
}).annotations({
    identifier: `${exports.NAMESPACE}.SearchUsersQuery`,
});
exports.AccountQuery = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('User id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.AccountQuery`,
});
exports.EmailQuery = effect_1.Schema.Struct({
    email: effect_1.Schema.propertySignature(effect_1.Schema.String.annotations({ jsonSchema: { type: 'string', format: 'email' } })),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailQuery`,
});
//# sourceMappingURL=schema.js.map